"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var configurationTypes_1 = require("../shared/types/configurationTypes");
var getDefaultLanguage = function () {
    var defaultLangugae = configurationTypes_1.LanguageType['de-DE'];
    return defaultLangugae;
};
exports.default = getDefaultLanguage;
